export const getWaitlistFrontData = <T extends Record<string, any> = Record<string, any>>(): T => {
  if (typeof window === 'undefined') {
    return {} as T;
  }

  const globals = window as any;
  return (globals.ipsOrderWaitlistFrontData || globals.ipsReactWaitlistData || {}) as T;
};
